import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeSubscribers } from '../actions';
import SubscribersActions from '../components/SubscribersActions';
import SubscribersPanel from '../components/SubscribersPanel';

export default (urls, access, entity = '') => ({
  ...tabTemplate('subscribers', SubscribersPanel, matchSingleUrl([...urls, 'subscribers']), SubscribersActions),
  ...tabCloser('closeSubscribersTab', closeSubscribers),
  ...tabIcons('eye'),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2], entity),
  order: 290,
  position: 'bottom-right',
});
